<template>
  <div>
      <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-toolbar-title class="subtitle-2">{{$t('statutoryexportcommonused.noparamter')}}</v-toolbar-title>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4">
            <v-btn color="warning" style="width: 100px" @click="getAmbankExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
     Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      pageTitle: this.$t('alleis.defaulteisexportformat'),

      id: this.parentObject.id,
      data: this.parentObject.data,
      
      titleData: null,
      eisdata: [],


      totalContAmt: null,

      accErr: [],
      negErrMsg: [],
      salhdErr: [],
      gettotalAmt: [],

      loading: false,

      processedCount: null,
      successCount: null,
      errCount: null,
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {
     getAmbankExportListHandler() {
      this.loading = true;
      const vm = this

      let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");

      this.$store.dispatch('get', {
        url:  `/defaulteisexport/all/${this.$store.getters.userId}`
        + "/" +  this.data.eisexprecid
        + "/" + this.data.refnum + "/" + date + "/" + date})
      .then(function (res) {
        
        vm.loading = false;
        vm.eisdata = res.data.rec;

        vm.exportHandler(); 
        
        // eisdataholder = eisdataholder.filter(e => {
        //   for (let i = 0; i < vm.data.eissubrecpy.length; i++) {
        //     if (e.poid == vm.data.eissubrecpy[i].pyctrlid) {
        //       return e
        //     }
        //   }
        // })
        // eisdataholder = eisdataholder.filter(e => e.stfamount != 0)

        // for (let i = 0; i < eisdataholder.length; i++) {
        //   vm.eisdata.push(eisdataholder[i])
        // }

      })
      .catch(function (err) {
        vm.errMsg = err;
      });
    },

    async getData() {
      const vm = this
      let body = []
      let holdpaycontamt = []
      let neweisdetail = []
      let dataholder = vm.eisdata
      let eisdetail = this.filter(dataholder);

      this.processedCount = dataholder.length;
      this.successCount = eisdetail.length;
      this.errCount = dataholder.length - eisdetail.length;
     // let getyear = this.data.year.toString()

      eisdetail.forEach(function (o) {
        var existing = neweisdetail.filter(function (i) {
          return i.staffcode === o.staffcode;
        })[0];
        if (!existing || existing == undefined) {
          neweisdetail.push(o);
        } else {
          existing.amount += o.amount;
        }
      });

      neweisdetail.forEach(element => {
        let dateHolder1 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.padRJ(1, 2);
        let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
              
        let date1 = moment(dateHolder1).format("YYYY-MM-DD");
        let date2 = moment(dateHolder2).format("YYYY-MM-DD"); 

        let monthcontribution;
        let dateget = ''
        let emptstatus = ''
      
        let icnoholder = ''
        let regnoholder = ''
        if (element.icno != null) icnoholder = element.icno.split("-").join("")
        if (element.regno != null) regnoholder = element.regno.split("-").join("")

        if(element.refno)
        {
          icnoholder = String(element.refno);//overwrite icno
        }
        else{
          icnoholder = ''; // As requested by N, if not found leave empty
        }

        if (date1 <= element.hiredate && date2 >= element.hiredate) {
          dateget = moment(element.hiredate).format("DDMMYYYY") 
          emptstatus = "B";
        }
                      
        if (date1 <= element.cessadate && date2 >= element.cessadate) { 
          dateget = moment(element.cessadate).format("DDMMYYYY");
          emptstatus = "H";
        }
        monthcontribution = this.padRJ(vm.data.month, 2) + vm.data.year;
        let contamtholder = element.amount.toFixed(2);
        contamtholder = contamtholder.split(".").join("");
        body.push({
          "Employer EIS Number": this.padSpaceLJ(this.data.refnum.replace(/-/g, ''), 12),
          "MyCoID/SSM Number": this.padSpaceLJ(regnoholder, 20),
          // "ID Number": this.padSpaceLJ(element.icno ? icnoholder : element.refno.replace(/-/g, ''), 12),
          "ID Number": this.padSpaceLJ(icnoholder.replace(/[-\s]/g, ''), 12),
          "Employee Name": this.padSpaceLJ(element.psnname, 150),
          "Contribution Month": this.padRJ(monthcontribution, 6),
          "Contribution Amount": this.padRJ(contamtholder, 14),
          "Employment Date": this.padSpaceRJ(dateget, 8),
          "Employment Status": this.padSpaceRJ(emptstatus, 1),
        });

        holdpaycontamt.push(element.amount);
      });

      if (holdpaycontamt) {
        let totalPayAmtHolder = holdpaycontamt.reduce(function (a, b) {return a + b}, 0);
        this.totalContAmt = totalPayAmtHolder.toFixed(2);
      }

      this.titleData = this.padRJ(vm.data.month, 2) + "_" + vm.data.year + "_EIS";

      if (body.length > 0) {
        const txtData = this.objectToTxt(body);
        this.download(txtData, this.titleData);
      }
    },

    filter(item) {
      let checkdet = this.detailfilter(item)
      let checkactive = this.activefilter(checkdet)
      let checkpayment = this.paymentfilter(checkactive)
      return checkpayment
    },

    detailfilter(item) {
        let dateHolder = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" 
        + this.daysInMonth(this.data.month, this.data.year);
        let date = moment(dateHolder).format("YYYY-MM-DD");
        let dataitem = item.filter(e => e.refnum == this.data.refnum)
        dataitem = dataitem.filter(e => {
            return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD")
        })
        let noacc = item.filter((e) => !dataitem.includes(e));
        for (let i = 0; i < noacc.length; i++) {
            noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
            this.accErr.push(noacc[i]);
        }
        return dataitem
    },

    activefilter(item) {
      let data = item.filter(e => e.pystatcode == 'ACTIVE')
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data
    },

    paymentfilter(item) {
      let data = item.filter(e => {
          return e.amount != 0
      })
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data
    },

    objectToTxt(data) {
      const csvRows = [];

      const headers = Object.keys(data[0]);

      //loop over the rows
      for (const row of data) {
        const values = headers.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `${escaped}`;
        });
        csvRows.push(values.join(""));
      }

      return csvRows.join("\n");
    },

    download(data, title) {
      // const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text" });
      const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".txt");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    padRJ(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    padLJ(num, size) {
      var s = num + "";
      while (s.length < size) s = s + "0";
      return s;
    },

    padSpaceRJ(char, size) {
      var s = char + "";
      while (s.length < size) s = " " + s;
      return s;
    },

    padSpaceLJ(char, size) {
      var s = char + "";
      while (s.length < size) s = s + " ";
      return s;
    },

    exportHandler() {
       
        this.getData();
        let item = [];
        item.totalContAmt = this.totalContAmt;
        item.accounterr = this.accErr;
        item.successCount = this.successCount;
        item.processedCount = this.processedCount;
        item.errCount = this.errCount;

        if (!this.isErr) {
          this.$router.push({ name: "monthlyeisexportlog", params: { item } });
        }
      
    },

    backHandler() {
      this.$router.push({ name: "monthlyeisexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

    mounted() {
      
    },
};
</script>